import { useEffect, useRef, useState } from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import SeoHead from "../components/SeoHead";

export default function OmOss() {
  const ref = useRef(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {if (entry.isIntersecting) setVisible(true);},
      { threshold: 0.1 }
    );
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);

  const team = [
  {
    name: "Siv.ing. Nikoletta Klaudia",
    role: "Daglig leder / siv.Ingeniør og Yachtkonstruktør",
    bio: "Fokuserer på prosjektering og prosessoptimalisering. Ansvarlig for strategisk utvikling av selskapet og retningen LYKKE-merket tar. Styrer nøkkelprosjekter, forretningsforhold og organisasjonens langsiktige visjon.",
    image: "https://media.base44.com/images/public/69ddf0e05a57ca57b48414c4/d6380ee86_WhatsAppImage2026-08-19at155925.jpeg"
  },
  {
    name: "Arthur",
    role: "Prosjektleder / møbelsnekker",
    bio: "Ansvarlig for tekniske løsninger og detaljer i utførelsen. En riktig oppbygget badstue gir jevn oppvarming, stabil temperatur og sikrer lang levetid på materialer og detaljer.",
    image: "https://media.base44.com/images/public/69cd72579c1c23d07f425ea3/af680af57_Zmien_Arturowi_ubranie_i_pospr_Nano_Banana_Pro_32826.jpg"
  },
  {
    name: "Karoline",
    role: "Økonomiansvarlig og administrasjon",
    bio: "Sørger for stabil drift, tydelig økonomistyring og oppfølging av dokumentasjon og garantier.",
    image: "https://media.base44.com/images/public/69cd72579c1c23d07f425ea3/fd36fe4cf_Dodaj_zdjecie_Karoliny_siedzac_Nano_Banana_Pro_97151.jpg"
  }];


  return (
    <div className="min-h-screen bg-background">
      <SeoHead
        title="Om oss – LYKKE NOMAD | Premium badstuer Oslo"
        description="LYKKE NOMAD er et norsk firma som designer og bygger premium badstuer. Møt teamet bak merkevaren – arkitekter, ingeniører og håndverkere med lidenskap for nordisk estetikk."
        canonical="https://lykke.info/om-oss"
      />
      <Navbar />
      
      {/* Hero */}
      <section className="relative h-96 md:h-[500px] overflow-hidden bg-background flex items-center justify-center">
        <div className="text-center text-white max-w-2xl px-6">
          <p className="text-white/70 mb-4 text-lg font-body uppercase tracking-widest-2xl">OM OSS

          </p>
          <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-light leading-[1.1] text-[#2a1810]">
            LYKKE utvikler badstuer
            <br />
            <span className="italic">for varme og ro</span>
          </h1>
        </div>
      </section>

      {/* Philosophy section */}
      <section className="py-24 md:py-40">
        <div className="max-w-[1440px] mx-auto px-6 md:px-12">
          <div className="grid lg:grid-cols-2 gap-16 lg:gap-24">
            <div className="text-2xl">
              <p className="text-foreground/70 mb-6 font-body leading-relaxed">Enkle prinsipper, tydelig form, riktige proporsjoner og materialer som fungerer over tid. Hver løsning er gjennomtenkt og tilpasset stedet den skal stå.

              </p>
              <p className="text-foreground/70 mb-6 font-body leading-relaxed">Vi ser på badstuen som en naturlig del av omgivelsene, enten det er i en privat hage, ved en hytte eller som del av et større prosjekt. Det handler om å skape en sammenheng mellom det som allerede er der og det som skal komme.

              </p>
              <p className="text-foreground/70 font-body leading-relaxed">Det vi lager skal være enkelt å bruke, riktig å plassere og fornuftig å investere i.

              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Why sauna */}
      <section className="py-24 md:py-40 bg-secondary/30">
        <div className="max-w-[1440px] mx-auto px-6 md:px-12">
          <div className="max-w-2xl" style={{ fontSize: "23px" }}>
            <p className="text-primary mb-6 font-body uppercase tracking-widest-2xl">HVORFOR BADSTUE

            </p>
            <h2 className="font-heading text-3xl md:text-5xl font-light leading-[1.1] mb-12">
              Badstuen er en enkel og naturlig del
              <br />
              <span className="italic">av det å ta vare på seg selv.</span>
            </h2>

            <div className="space-y-6 text-2xl">
              <p className="text-foreground/70 font-body leading-relaxed">Badstuen er en enkel og naturlig del av det å ta vare på seg selv, en praktisk måte å støtte kroppen og finne ro i hverdagen.

              </p>
              <p className="text-foreground/70 font-body leading-relaxed" style={{ fontSize: "23px" }}>Regelmessig bruk av badstue kan bidra til å styrke immunforsvaret, redusere stressnivået og forbedre sirkulasjonen. Mange opplever også bedre søvn og økt konsentrasjon.

              </p>
              <p className="text-foreground/70 font-body leading-relaxed">For eiendom kan en godt integrert badstue også ha en tydelig verdi. Den kan gjøre boligen mer attraktiv ved salg, skille den ut i markedet og bidra til økt leie eller salgsverdi.

              </p>
              <p className="font-heading font-light italic text-foreground/80 pt-4" style={{ fontSize: "23px" }}>
                Det er verdt å ha badstue hjemme.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Team */}
      <section ref={ref} className="py-24 md:py-40">
        <div className="max-w-[1440px] mx-auto px-6 md:px-12">
          <div className="mb-20">
            <p className="text-sm tracking-widest-2xl font-body uppercase text-primary mb-6">
              Teamet
            </p>
            <h2 className="font-heading text-3xl md:text-5xl font-light leading-[1.1]">
              Meet LYKKE
            </h2>
          </div>

          <div className="grid md:grid-cols-3 gap-12">
            {team.map((member, i) =>
            <div
              key={i}
              className={`transition-all duration-700 ${
              visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`
              }
              style={{ transitionDelay: `${i * 150}ms` }}>
              
                <div className="aspect-[3/4] overflow-hidden mb-6">
                  <img
                                     src={member.image}
                                     alt={member.name}
                                     className="w-full h-full object-cover"
                                     width="600"
                                     height="800"
                                     loading="lazy"
                                     decoding="async" />
                
                </div>
                <h3 className="mb-1 text-xl font-light">
                  {member.name}
                </h3>
                <p className="text-primary/70 mb-4 text-lg font-body uppercase tracking-widest-xl">
                  {member.role}
                </p>
                <p className="text-foreground/60 font-body leading-relaxed text-2xl">
                   {member.bio}
                </p>
              </div>
            )}
          </div>
        </div>
      </section>

      <Footer />
    </div>);

}